import { apiClient, type Paginated } from '@/core/api';
import type { CalendarEvent, CalendarEventInput } from './types';

const BASE = '/collab/calendar-events/';

export interface CalendarEventListParams {
  page?: number;
  search?: string;
  owner?: number;
  kind?: string;
  /** ISO datetime bounds on starts_at (inclusive). */
  starts_after?: string;
  starts_before?: string;
}

export async function listCalendarEvents(
  params: CalendarEventListParams = {},
): Promise<Paginated<CalendarEvent>> {
  const { data } = await apiClient.get<Paginated<CalendarEvent>>(BASE, { params });
  return data;
}

export async function createCalendarEvent(input: CalendarEventInput): Promise<CalendarEvent> {
  const { data } = await apiClient.post<CalendarEvent>(BASE, input);
  return data;
}

export async function updateCalendarEvent(
  id: number,
  input: Partial<CalendarEventInput>,
): Promise<CalendarEvent> {
  const { data } = await apiClient.patch<CalendarEvent>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteCalendarEvent(id: number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}
